import { FC } from "react";
import { Avatar, PresenceIndicator } from "@benefit-systems/hr-tools-ui";
import { Typography } from "@mui/material";
import __ from "src/utils/Translations";
import { IEmployeeDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";

interface IEmployeesAutocompleteAdornmentProps {
  data?: IEmployeeDetails | null;
}

const EmployeesAutocompleteAdornment: FC<
  IEmployeesAutocompleteAdornmentProps
> = ({ data }) => (
  <>
    <PresenceIndicator status={data?.presenceStatus}>
      <Avatar src={data?.avatarUrl} alt="avatar">
        {data?.initials ?? ""}
      </Avatar>
    </PresenceIndicator>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        fontSize: "12px",
        lineHeight: "1",
        position: "absolute",
        left: "62px",
        top: "31px",
      }}
    >
      {data?.position || __("Brak stanowiska")}
    </Typography>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        fontSize: "12px",
        lineHeight: "1",
        position: "absolute",
        left: "62px",
        top: "46px",
      }}
    >
      {__("Numer pracownika")}: {data?.fkNumber}
    </Typography>
  </>
);

export default EmployeesAutocompleteAdornment;
